__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-journey/v8_19_10/";